export enum Align {
  Left = 'left',
  Right = 'right',
  // Note: itemas below are not yet used
  Center = 'center',
  Top = 'top',
  Bottom = 'bottom'
}
